<template>
  <section class="section container pt-5">
    <scripts-datatable />
  </section>
</template>

<script>
import ScriptsDatatable from "./scripts_datatable/Index.vue";

export default {
  name: "ScriptIndex",
  components: { ScriptsDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
